export default __webpack_public_path__ + "static/media/Yashi Tomar.25d96a9b.JPG";